import validate from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import routing_45global from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/middleware/routing.global.ts";
export const globalMiddleware = [
  validate,
  routing_45global
]
export const namedMiddleware = {}